import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=2405d998&scoped=true&"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405d998",
  null
  
)

export default component.exports